
import { useRef, useState } from 'react';
import { Button, Col, Form, Row, Popover } from 'react-bootstrap';
import Select from 'react-select';

import { ModalFiltrosComponent, PopoverFiltrosComponent } from './components';

import InputDataCombo from "../../../../../Componentes/InputDataCombo";
import ComboIntegracaoSistemas from '../../../../../Componentes/ComboIntegracaoSistemas';
import ComboServidores from '../../../../../Componentes/ComboServidores';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortAmountDown } from '@fortawesome/free-solid-svg-icons';
import { intersectObject } from '../../../../../Funcoes';

export default function ModalFiltros({
    elemento,
    mostrar,
    alterarMostrar,
    parametros,
    alterarParametros
}){

    // estados
    const filtrosPadrao = {
        pesquisa: null,
        status: null,
        idsIntegracaoSistema: null,
        idServidorAluguel: null,
        dataInicio: null,
        dataFinal: null,
        ordenarCampos: ['geral']
    };
    const [ filtros, alterarFiltros ] = useState(intersectObject({...filtrosPadrao}, parametros ?? {}));
    const refs = {
        dataInicioCol: useRef(null),
        dataFinalCol: useRef(null)
    };

    const ordenarCampos = [
        {label: 'Uso geral', value: 'geral'},
        {label: 'Uso v1', value: 'v1'},
        {label: 'Uso v2', value: 'v2'},
        {label: 'Uso v3', value: 'v3'}
    ];

    // prepara filtro de status
    const status = [
        {label: 'Concluído', value: 'concluido'},
        {label: 'Aguardando', value: 'aguardando'},
        {label: 'Integrando', value: 'integrando'},
        {label: 'Atraso', value: 'emAtraso'}
    ];

    // função para limpar os filtros
    function limparFiltros(){

        // prepara
        let filtrosAlterar = {...filtros};

        // percorre filtros
        Object.keys(filtros).map((filtro) => {

            // limpa
            filtrosAlterar[filtro] = filtrosPadrao[filtro] ?? null;

        });

        // altera
        alterarFiltros(filtrosAlterar);
        // alterarParametros({...parametros, ...filtrosAlterar});

    }

    // função para cancelar (sair sem aplicar)
    function cancelar(){

        // fecha
        alterarMostrar(false);

        // altera os filtros para o estado inicial
        let filtrosAlterar = {...filtros};

        // percorre
        Object.keys(filtros).map((filtro) => {

            // altera
            filtrosAlterar[filtro] = parametros[filtro] ?? filtrosPadrao[filtro] ?? null;
        });

        // altera os filtros
        alterarFiltros(filtrosAlterar);

    }

    return <ModalFiltrosComponent
        show={mostrar}
        target={elemento}
        placement="bottom"
        rootClose
        onHide={() => {
            cancelar();
        }}
    >
        <PopoverFiltrosComponent
            size={'sm'}
            title={'Filtros'}
        >
            <Popover.Title>
                Filtros
                <Button
                    size="sm"
                    name="botao-limpar"
                    onClick={() => {

                        // limpa filtros
                        limparFiltros();
                    }}
                >
                    Limpar
                </Button>
            </Popover.Title>
            <Popover.Content>
                <Row>
                    <Col>
                        <Form.Label>Pesquisa <small>(empresa)</small></Form.Label>
                        <Form.Control 
                            value={filtros.pesquisa || ''}
                            onChange={e => {

                                // altera
                                alterarFiltros({...filtros, pesquisa: e.target.value});
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Label>Servidor</Form.Label>
                        <ComboServidores
                            className="select-ficha"
                            id={filtros.idServidorAluguel || null}
                            config={{
                                pagina: null,
                                registrosPorPagina: null
                            }}
                            alterou={(idServidorAluguel) => {

                                // altera
                                alterarFiltros({...filtros, idServidorAluguel});
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Label>Integração</Form.Label>
                        <ComboIntegracaoSistemas
                            className="select-ficha"
                            isMulti={true}
                            valor={filtros.idsIntegracaoSistema}
                            aoAlterar={(idsIntegracaoSistema) => {
                                
                                // altera
                                alterarFiltros({
                                    ...filtros,
                                    idsIntegracaoSistema
                                });
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Label>Data</Form.Label>
                        <Row>
                            <Col className='position-relative' ref={refs.dataInicioCol}>
                                {refs.dataInicioCol.current && <InputDataCombo
                                    size="sm"
                                    placeholder="A partir de"
                                    data={filtros.dataInicio}
                                    onChange={(novaData) => {
                                        alterarFiltros({...filtros, dataInicio: novaData})
                                    }}
                                    options={{
                                        appendTo: refs.dataInicioCol.current
                                    }}
                                />}
                            </Col>
                            <Col className='position-relative' ref={refs.dataFinalCol}>
                                {refs.dataFinalCol.current && <InputDataCombo
                                    size="sm"
                                    placeholder="Até"
                                    data={filtros.dataFinal}
                                    onChange={(novaData) => {
                                        alterarFiltros({...filtros, dataFinal: novaData})
                                    }}
                                    options={{
                                        appendTo: refs.dataFinalCol.current
                                    }}
                                />}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <Form.Label>
                            <span className='d-flex align-items-center' style={{gap: '0.125em'}}>
                                <FontAwesomeIcon color="#404040" icon={faSortAmountDown} />
                                Ordenar por
                            </span>
                        </Form.Label>
                        <Select
                            className="select-ficha"
                            size="sm"
                            options={ordenarCampos}
                            value={ordenarCampos.find((s) => filtros.ordenarCampos && filtros.ordenarCampos.includes(s.value))}
                            isMulti={false}
                            placeholder='Sem filtro'
                            onChange={(ordenarCampos) => {
                                
                                // altera os filtros selecionados
                                alterarFiltros({
                                    ...filtros,
                                    ordenarCampos: (
                                        ordenarCampos ? [ordenarCampos.value] : null
                                    )
                                });
                            }}
                        />
                    </Col>
                </Row>

                <div className='footer'>
                    <Button
                        size="sm"
                        variant={'light'}
                        onClick={() => {

                            // cancela
                            cancelar();
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        size="sm"
                        variant={'success'}
                        onClick={() => {

                            // altera os parâmetros
                            alterarParametros({...parametros, ...filtros, pagina: 1});
                        }}
                    >
                        Aplicar
                    </Button>
                </div>
            </Popover.Content>
        </PopoverFiltrosComponent>
    </ModalFiltrosComponent>
    
}